import { EpDevPDocumentTypes } from "../../constants";
import EpDevPUtils from "../../EpDevPUtils";
import { 
  TApplicationDomainsApiBasePathParam, 
  TApplicationDomainsApiByIdPathParams,
  TApplicationDomainsApiByIdQueryParams,
  TApplicationDomainsApiReplaceCacheQueryParams,
  TApplicationDomainsApiDeleteCacheQueryParams,
  TApplicationDomainsApiListCachedQueryParams
} from "../types";

const APPLICATION_DOMAINS = "applicationDomains";
const CACHE = "cache";
const CACHED = "cached";

export class EpDevPApplicationDomainsApiRoutesFactory {

  public static getSubRouteBase = (): string => {
    return `/:${EpDevPUtils.nameOf<TApplicationDomainsApiBasePathParam>('organizationId')}/${APPLICATION_DOMAINS}`;
  }
  public static getSubRouteList = (): string => { 
    return EpDevPApplicationDomainsApiRoutesFactory.getSubRouteBase();
  }
  public static getSubRouteListCached = (): string => { 
    return `${EpDevPApplicationDomainsApiRoutesFactory.getSubRouteBase()}/${CACHED}`;
  }
  public static getSubRouteById = (): string => {
    return `${EpDevPApplicationDomainsApiRoutesFactory.getSubRouteBase()}/:${EpDevPUtils.nameOf<TApplicationDomainsApiByIdPathParams>('applicationDomainId')}`;
  }
  private static getSubRouteCache = (): string => {
    return `${EpDevPApplicationDomainsApiRoutesFactory.getSubRouteBase()}/${CACHE}`;
  }
  public static postSubRouteCacheCreate = (): string => {
    return `${EpDevPApplicationDomainsApiRoutesFactory.getSubRouteCache()}`;
  }
  public static putSubRouteCacheReplace = (): string => {
    return `${EpDevPApplicationDomainsApiRoutesFactory.getSubRouteCache()}`;
  }
  public static deleteSubRouteCacheDelete = (): string => {
    return `${EpDevPApplicationDomainsApiRoutesFactory.getSubRouteCache()}`;
  }
}

export class EpDevPApplicationDomainsApiPathsFactory {

  public static createListApplicationDomainsPath({ organizationId }: {
    organizationId: string;
  }): string {
    return `/${organizationId}/${APPLICATION_DOMAINS}`;
  }

  public static createListCachedApplicationDomainsPath({ organizationId, documentTypes }: {
    organizationId: string;
    documentTypes?: Array<EpDevPDocumentTypes>;
  }): string {
    const queryParams: string[] = [];
    if(documentTypes !== undefined && documentTypes.length > 0) {
      queryParams.push(`${EpDevPUtils.nameOf<TApplicationDomainsApiListCachedQueryParams>("documentTypes")}=${documentTypes.join(',')}`);
    }
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${APPLICATION_DOMAINS}/${CACHED}?${queryString}`;
  }

  public static createByIdPath({ organizationId, applicationDomainId, add2CacheId }:{
    organizationId: string;
    applicationDomainId: string;
    add2CacheId?: string;
  }): string {
    const queryParams: string[] = [];
    if(add2CacheId !== undefined) {
      queryParams.push(`${EpDevPUtils.nameOf<TApplicationDomainsApiByIdQueryParams>("add2CacheId")}=${add2CacheId}`);
    }
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${APPLICATION_DOMAINS}/${applicationDomainId}?${queryString}`;
  }

  public static createCacheCreatePath({ organizationId }:{
    organizationId: string;
  }): string {
    return `/${organizationId}/${APPLICATION_DOMAINS}/${CACHE}`;
  }

  public static createCacheReplacePath({ organizationId, sourceCacheId, organizationDocumentType }:{
    organizationId: string;
    sourceCacheId: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): string {
    const queryParams: string[] = [];
    queryParams.push(`${EpDevPUtils.nameOf<TApplicationDomainsApiReplaceCacheQueryParams>("sourceCacheId")}=${sourceCacheId}`);
    queryParams.push(`${EpDevPUtils.nameOf<TApplicationDomainsApiReplaceCacheQueryParams>("organizationDocumentType")}=${organizationDocumentType}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${APPLICATION_DOMAINS}/${CACHE}?${queryString}`;
  }

  public static createCacheDeletePath({ organizationId, tempCacheId, organizationDocumentType }:{
    organizationId: string;
    tempCacheId?: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): string {
    const queryParams: string[] = [];
    if(tempCacheId) queryParams.push(`${EpDevPUtils.nameOf<TApplicationDomainsApiDeleteCacheQueryParams>("tempCacheId")}=${tempCacheId}`);
    queryParams.push(`${EpDevPUtils.nameOf<TApplicationDomainsApiDeleteCacheQueryParams>("organizationDocumentType")}=${organizationDocumentType}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${APPLICATION_DOMAINS}/${CACHE}?${queryString}`;
  }

}

